import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import gtag from './gtag.js'


const apix = axios.create({
  baseURL: 'https://api.illustrationx.com/'
})

const dapix = axios.create({
  baseURL: 'https://imaging.illustrationx.com/v1/dev/'
})

const imagehost = "https://media.illustrationx.com"


Vue.prototype.$emailImageUrl = function (item) {
  return imagehost + '/mediastore/emails/' + item
}

Vue.prototype.$apix = apix
Vue.prototype.$dapix = dapix
Vue.prototype.$host = 'https://www.illustrationx.com'
Vue.prototype.$imagehost = imagehost
Vue.prototype.$assetUrl = function (item) {
  return imagehost + '/mediastore/newtalent/' + item
}


Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  gtag.loadGoogle(to)
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
